import React from 'react'
import NavigationDrawer from '../../component/navigation-drawer/navigation-drawer.component'

const WithDrawer = (WrappedComponent) => {
    const hocComponent = (props) => {
        return (
            <div>
                <NavigationDrawer />
                <WrappedComponent />
            </div>
        )
    }

    return hocComponent
}

export default WithDrawer;